import _ from 'lodash';
import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import './KuaibaoBanner.scss';
import { track, isomorphicConfig } from '../../utility';
type Props = {
  exposureSharelp: Object,
  kuaibaoBannerImage: String,
};
export default class KuaibaoBanner extends React.PureComponent<Props, *> {
  componentDidMount() {
    track({
      location: 'sharelp',
      action: 'expose',
      object: 'sharelp_kuaibao_banner_expose',
      id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
      ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
    });
  }
  @autobind
  kuaibaoBannerClick() {
    track({
      location: 'sharelp',
      action: 'click',
      object: 'sharelp_kuaibao_banner_click',
      id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
      ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
    });
    const url = _.get(isomorphicConfig, 'kuaibaoBanner.url', '');

    if (url) {
      window.location.href = url;
    }
  }

  render() {
    const { kuaibaoBannerImage } = this.props;
    return (
      <div className="article-share-kuaibao-banner" onClick={this.kuaibaoBannerClick}>
        <img alt="" src={kuaibaoBannerImage} />
      </div>
    );
  }
}
